import React from "react";
import { Badge } from "@chakra-ui/react";

export default function StatusChip({ status }) {
  if (!status) return null;

  let colorScheme = "gray";

  switch (status.toLowerCase()) {
    case "active":
      colorScheme = "green";
      break;
    case "redeemed":
      colorScheme = "orange";
      break;
    case "cancelled":
      colorScheme = "red";
      break;
    default:
      colorScheme = "gray";
  }

  return (
    <Badge
      colorScheme={colorScheme}
      px={3}
      py={2}
      borderRadius="md"
      textTransform="capitalize"
      fontSize="md"
    >
      {status}
    </Badge>
  );
}
